import VueI18Next from '@ringana/vue-i18next';
import * as sweetalert2 from 'sweetalert2';
import { IHandleErrorOptions } from '../common/interfaces/errors.interface';
import FetchError from '../errors/fetch-error';
import ValidationError from '../errors/validation-error';

export default class ErrorHandlerHelper {
  public static handleError(error: Error | string, options: IHandleErrorOptions): Promise<sweetalert2.SweetAlertResult> | undefined {
    let swal;
    if(options.logToConsole) {
      ErrorHandlerHelper.logError(error);
    }
    if(options.showSwal) {
      swal = ErrorHandlerHelper.prepareAndShowSwal(options, error);
    }
    return swal;
  }

  private static logError(error: Error | string): void {
    console.groupCollapsed(`logError function was called - ${typeof error === `object` ? error.message : error}`);
    if(typeof error === `string`) {
      console.trace(error);
    } else {
      console.trace(error.message);
      if(error instanceof FetchError || error instanceof ValidationError) {
        console.info(`Errorcode ${error.errorCode}`);
      }
    }
    console.groupEnd();
  }

  private static prepareAndShowSwal(options: IHandleErrorOptions, error: Error | string): Promise<sweetalert2.SweetAlertResult> {
    let swalMessage;
    if(options.swalMessage) {
      swalMessage = options.swalMessage;
    } else if(typeof error === `string`) {
      swalMessage = error;
    } else {
      swalMessage = JSON.stringify(error.message);
    }
    swalMessage = swalMessage.replace(`<`, `&lt;`).replace(`>`, `&gt;`);
    return window.$swal(``, swalMessage, `error`);
  }

  public static getTranslatedFetchErrorMessage(err: FetchError, i18n: VueI18Next): string | undefined {
    const translationKey = err.details && err.details.length > 0 && typeof err.details[0] === `object`
      ? err.details[0].translationKey
      : undefined;

    let translatedMessage;
    if(translationKey) {
      translatedMessage = i18n.i18next.t(`errors:${translationKey}`);
      if(translatedMessage === translationKey) {
        translatedMessage = i18n.i18next.t(`errors:fetchUnexpectedError`);
      }
    }

    return translatedMessage;
  }
}
